import { DateTime } from 'luxon';

export function formatDayKey(day: DateTime) {
  return day.setLocale('en').weekdayLong.toLocaleLowerCase();
}
